const CACHE_KEY = 'i18n_gt_cache'

type TranslationCache = Record<string, Record<string, string>>

const loadCache = (): TranslationCache => {
    try {
        const raw = localStorage.getItem(CACHE_KEY)
        return raw ? JSON.parse(raw) : {}
    } catch {
        return {}
    }
}

const cache: TranslationCache = loadCache()

export const getCache = (lang: string, key: string): string | undefined => {
    return cache[lang]?.[key]
}

export const setCache = (lang: string, key: string, value: string): void => {
    if (!cache[lang]) cache[lang] = {}
    cache[lang][key] = value
    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify(cache))
    } catch {
        // storage full — silently ignore
    }
}
